"use client";

import Input from "@/components/common/Input";
import TextArea from "@/components/common/TextArea";
import { useRef, useState, useEffect } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import Button from "../common/Button";
import { API } from "@/services/api/API";
import { usePathname } from "next/navigation";
import SelectInput from "@/components/contactUs/SelectInput";
import BouncerLoader from "../common/BouncerLoader";

type Props = {
    onClose: () => void;
};

const QuationForm = ({ onClose }: Props) => {
    const paths = usePathname();
    useEffect(() => {
        setFormData((prevData) => ({
            ...prevData,
            from: paths,
        }));
    }, [paths]);

   

    const initialFormData = {
        body: {
            name: "",
            company: "",
            email: "",
            phone: "",
            state: "",
            idState: "",
            idCity: "",
            city: "",
            from: paths,
            message: ""
        },
        reCaptchaToken: null as string | null,
        typeForm: "quantionForm",
        isLoading: false,
        responseMessage: "",
        showMessage: false,
    };
    
    const [formData, setFormData] = useState(initialFormData);

     useEffect(() => {
    console.log("Nuevo formData.body:", formData);
    }, [formData]);


    // Objeto para almacenar los mensajes de error
    const [errors, setErrors] = useState<{ [key: string]: string }>({});

    const messageTimer = () => {
        setTimeout(() => {
            setFormData((prevData) => ({
                ...prevData,
                showMessage: false,
            }));
            onClose();
        }, 5000);
    };


    const showMessage = (message: string) => {
        setFormData((prevData) => ({
            ...prevData,
            responseMessage: message,
            showMessage: true,
        }));
        messageTimer();
    };

    const recaptchaRef = useRef<ReCAPTCHA>(null);

    // Función para manejar el cambio en inputs y selects
    const handleChange = (
        e: React.ChangeEvent<
            HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
        >,
        stateSelected: null | true = null
    ) => {
        const { name, value } = e.target as HTMLInputElement;
        if (name === "phone") {
            const numericValue = value.replace(/\D/g, "");
            if (numericValue.length > 10) return;
            setFormData((prevData) => ({
                ...prevData,
                body: {
                    ...prevData.body,
                    [name]: numericValue,
                },
            }));
            return;
        }
        if (e.target instanceof HTMLSelectElement) {
            const selectedText = e.target.options[e.target.selectedIndex].text;
            console.log("name ", name, " value ", value, " selectedText ", selectedText);
            setFormData((prevData) => ({
                ...prevData,
                body: {
                    ...prevData.body,
                    [name]: selectedText,
                    ...(stateSelected ? {idState : value} : {idCity: value}),
                },
            }));
        }else {
            setFormData((prevData) => ({
                ...prevData,
                body: {
                    ...prevData.body,
                    [name]: value,
                },
            }));
        }

    };

    // Función para capturar el cambio del reCAPTCHA
    const handleRecaptchaChange = (token: string | null) => {
        setFormData((prevData) => ({
            ...prevData,
            reCaptchaToken: token,
        }));
    };

    // Función de validación manual
    const validate = () => {
        const newErrors: { [key: string]: string } = {};

        if (!formData.body.name.trim()) {
            newErrors.name = "El nombre es requerido";
        }
        if (!formData.body.company.trim()) {
            newErrors.company = "La empresa es requerida";
        }
        if (!formData.body.email.trim()) {
            newErrors.email = "El correo es requerido";
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.body.email)) {
            newErrors.email = "El correo no es válido";
        }
        if (!formData.body.phone.trim()) {
            newErrors.phone = "El teléfono es requerido";
        } else if (!/^\d+$/.test(formData.body.phone)) {
            newErrors.phone = "El teléfono debe contener solo números";
        }
        if (!formData.body.idState.trim()) {
            newErrors.state = "El estado es requerido";
        }
        if (!formData.body.idCity.trim()) {
            newErrors.city = "La ciudad es requerida";
        }
        if (!formData.reCaptchaToken) {
            newErrors.reCaptchaToken = "Por favor, verifica que no eres un robot";
        }

        return newErrors;
    };

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        console.log("formData", formData);
    
        setFormData((prevData) => ({
            ...prevData,
            isLoading: true,
        }));
    
        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            setFormData((prevData) => ({
                ...prevData,
                isLoading: false,
            }));
            return;
        }
    
        if (!formData.reCaptchaToken) {
            setFormData((prevData) => ({
                ...prevData,
                isLoading: false,
            }));
            return;
        }
    
        try {
            const formDataToSend = new FormData();
            formDataToSend.append("body", JSON.stringify(formData.body));
            formDataToSend.append("reCaptchaToken", formData.reCaptchaToken || "");
            formDataToSend.append("typeForm", formData.typeForm);
            console.log("formDataToSend", formDataToSend);
            const formResponse = (await API.contactUsForm.sendContactUsForm(
                formDataToSend
            )) as { response: string };
    
            showMessage(formResponse.response);
        } catch (err) {
            showMessage("Ocurrió un error al enviar el formulario");
            console.error("Error al enviar el formulario.", err);
        }
    
        recaptchaRef.current?.reset();
        setErrors({});
        setFormData((prevData) => ({
            ...initialFormData,
            responseMessage: prevData.responseMessage,
            showMessage: prevData.showMessage,
            body: {
                ...initialFormData.body,
                from: paths,
            },
        }));
        
    };
    

    return (
        <form className="mt-2" onSubmit={handleSubmit}>
            <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                <div className="row">
                    <Input
                        label="Nombre*"
                        name="name"
                        value={formData.body.name}
                        onChange={(e) => handleChange(e, null)}
                        className="bg-white border-gray02 border w-full h-10 p-2"
                        labelClass="mb-2 text-dark02"
                    />
                    {errors.name && <p className="text-red-500 text-xs">{errors.name}</p>}
                </div>
                <div>
                    <Input
                        label="Empresa*"
                        name="company"
                        value={formData.body.company}
                        onChange={(e) => handleChange(e, null)}
                        className="bg-white border-gray02 border w-full h-10 p-2"
                        labelClass="mb-2 text-dark02"
                    />
                    {errors.company && <p className="text-red-500 text-xs">{errors.company}</p>}
                </div>
            </div>
            <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                <div className="row">
                    <Input
                        label="Correo*"
                        name="email"
                        value={formData.body.email}
                        onChange={(e) => handleChange(e, null)}
                        className="bg-white border-gray02 border w-full h-10 p-2"
                        labelClass="mb-2 text-dark02"
                    />
                    {errors.email && <p className="text-red-500 text-xs">{errors.email}</p>}
                </div>
                <div>
                    <Input
                        label="Número de teléfono*"
                        name="phone"
                        value={formData.body.phone}
                        onChange={(e) => handleChange(e, null)}
                        className="bg-white border-gray02 border w-full h-10 p-2"
                        labelClass="mb-2 text-dark02"
                    />
                    {errors.phone && <p className="text-red-500 text-xs">{errors.phone}</p>}
                </div>
            </div>

            <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                <div className="row">
                    <SelectInput
                        label="Estado*"
                        name="state"
                        value={formData.body.idState}
                        onChange={(e) => handleChange(e, true)}
                        className="bg-white border-gray02 border w-full h-10 p-2"
                        labelClass="mb-2 text-dark02"
                    />
                    {errors.state && <p className="text-red-500 text-xs">{errors.state}</p>}
                </div>
                <div>
                    <SelectInput
                        label="Ciudad*"
                        name="city"
                        value={formData.body.idCity}
                        onChange={(e) => handleChange(e, null)}
                        className="bg-white border-gray02 border w-full h-10 p-2"
                        slug={formData.body.idState}
                        labelClass="mb-2 text-dark02"
                    />
                    {errors.city && <p className="text-red-500 text-xs">{errors.city}</p>}
                </div>
            </div>

            <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                <div className="row">
                    <TextArea
                        label="Mensaje"
                        name="message"
                        id="message"
                        value={formData.body.message}
                        onChange={(e) => handleChange(e, null)}
                        className="bg-white border-gray02 border w-full h-[140px] p-2"
                        labelClass="mb-2 text-dark02"
                    />
                </div>
                <div className="row items-center">
                    {process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY && (
                        <div className="flex justify-center flex-col items-center mt-12">
                            <ReCAPTCHA
                                ref={recaptchaRef}
                                sitekey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY}
                                onChange={handleRecaptchaChange}
                            />
                            {errors.reCaptchaToken && (
                                <p className="text-red-500 text-xs mt-2">
                                    {errors.reCaptchaToken}
                                </p>
                            )}
                        </div>
                    )}
                    <div className="flex justify-center w-full mt-5">
                        <Button
                            type="submit"
                            disabled={formData.isLoading}
                            className={
                                formData.isLoading
                                    ? "text-dark02 w-full  justify-center uppercase font-bold text-xl border-2 border-matco"
                                    : "bg-matco text-dark02 w-full  justify-center border-2 uppercase font-bold text-xl border-matco hover:text-matco hover:bg-transparent"
                            }
                        >
                            {formData.isLoading ? <BouncerLoader /> : "Enviar"}
                        </Button>
                    </div>
                </div>
            </div>
            {formData.showMessage && (
                <div className="bg-slate-300 p-4 text-center mt-4 w-full">
                    {formData.responseMessage}
                </div>
            )}
        </form>
    );
};

export default QuationForm;
